import ApiService from './api.service.js';

export default {
  fetchEmails(params) {
    return ApiService.get('/messages', { params });
  },
  resendEmail(admin) {
    const notification = 'admin_created';
    return ApiService.post(`/messages/${notification}/send`, JSON.stringify(admin));
  }
};
